// import { createSelector } from 'reselect';

import { AppState } from './state';

export const getParamByName = (_state: AppState, props: any, paramName:any) => {
  return props.match.params[paramName];
}
